import { Modal } from './Modal';

interface ConfirmModalProps {
  aberto: boolean;
  titulo: string;
  mensagem: string;
  textoConfirmar?: string;
  textoCancelar?: string;
  perigoso?: boolean;
  onConfirmar: () => void;
  onCancelar: () => void;
}

export function ConfirmModal({
  aberto, titulo, mensagem,
  textoConfirmar = 'Confirmar', textoCancelar = 'Cancelar',
  perigoso = false, onConfirmar, onCancelar,
}: ConfirmModalProps) {
  return (
    <Modal
      aberto={aberto}
      onFechar={onCancelar}
      titulo={titulo}
      largura={420}
      compacto
      rodape={
        <>
          <button type="button" className="btn-secundario" onClick={onCancelar}>{textoCancelar}</button>
          <button type="button" className={perigoso ? 'btn-perigo' : 'btn-primario'} onClick={onConfirmar}>{textoConfirmar}</button>
        </>
      }
    >
      <p>{mensagem}</p>
    </Modal>
  );
}
